import { MAPPABLE_ENTITIES, PdfFieldMapping } from '../../types';

export const isLegacyAnswerSource = (entity: string) => entity === 'et706' || entity === 'documentanswers';

/** PDF context describes a destination, never an application's source schema. */
export function mappingFieldOptions(entity: string, _fields: PdfFieldMapping[], selected = '') {
  const options = [...(MAPPABLE_ENTITIES[entity]?.fields || [])];
  // Keep an existing mapping inspectable while it is being replaced. Do not
  // promote other arbitrary PDF keys into selectable application properties.
  if (selected && !options.some(option => option.value === selected)) options.push({
    value: selected,
    label: `${isLegacyAnswerSource(entity) ? 'Legacy answer key (source review required)' : 'Saved field'}: ${selected}`,
  });
  return options;
}
